<div class="d-flex flex-column bg-login m-0">
  <div class="w-25 mx-auto">
    <div class="card px-2">
      <div class="card-header text-center">
        <div class="mx-auto logo-login mb-4"></div>
        <h5 class="mb-1">{{ "DCO.SSO_SSO_Title" | translate }}</h5>
        <p class="text-muted">{{ "DCO.SSO_SSO_Message" | translate
          }}</p>
      </div>
      <div class="card-body">
        <form class="mb-5" *ngIf="!isLoggedIn">
          <div *ngIf="!ssoError">
            <p class="text-muted">{{ "DCO.SSO_SsoInProgress" | translate
              }}<!-- el sistema está obteniendo los datos de auth --></p>
            <div class="form-group mb-3">
              <div  class="d-flex justify-content-center" style=" left: 50%">
                <div class="spinner-border spinner-border-smtext-customer"></div>
              </div>
            </div>
          </div>
          <div class="alert alert-danger" *ngIf="ssoError">
            {{ "DCO.SSO_SessionIdError" | translate }}
          </div>
            <div class="alert alert-danger" *ngFor="let error of lstErrors">
              {{error}}
            </div>
        </form>
      </div>
    </div>
  </div>
</div>